import React, { useEffect, useState } from "react";
import { Button, TextField, IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { useParams } from "react-router-dom";
import { collectionService } from "services/collectionService";
import { toast } from "react-toastify";
import { ethers } from "ethers";

const getDefaultPaymentCoins = (chainId) => {
  const cid = Number(chainId);
  if (cid === 25) {
    return {
      nativeName: "CRO",
      wrappedName: "WCRO",
      wrappedAddress: "0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23",
    };
  } else if (cid === 56) {
    return {
      nativeName: "BNB",
      wrappedName: "WBNB",
      wrappedAddress: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    };
  } else if (cid === 8453 || cid === 84532) {
    return {
      nativeName: "ETH",
      wrappedName: "WETH",
      wrappedAddress: "0x4200000000000000000000000000000000000006",
    };
  } else if (cid === 81457 || cid === 168587773) {
    return {
      nativeName: "ETH",
      wrappedName: "WETH",
      wrappedAddress: "0x4300000000000000000000000000000000000004",
    };
  } else {
    // Default fallback to Polygon/Amoy values
    return {
      nativeName: "POL",
      wrappedName: "WPOL",
      wrappedAddress: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
    };
  }
};

export default function CollectionPayment() {
  const { id } = useParams();
  const [paymentCoinOptions, setPaymentCoinOptions] = useState([]);
  const [collection, setCollection] = useState();

  const updatePaymentOptions = async () => {
    const payload = { paymentCoinOptions, chainId: collection.chainId };
    await collectionService.updatePaymentOptions(id, payload);
    toast.success("Payment options updated successfully");
  };

  const addPaymentOption = () => {
    setPaymentCoinOptions([...paymentCoinOptions, { address: "", name: "" }]);
  };

  const deletePaymentOption = (index) => {
    const newPaymentCoinOptions = [...paymentCoinOptions];
    newPaymentCoinOptions.splice(index, 1);
    setPaymentCoinOptions(newPaymentCoinOptions);
  };

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await collectionService.view(id);
      setCollection(data);
      const zeroAddress = ethers.constants.AddressZero.toLowerCase();
      const config = getDefaultPaymentCoins(data.chainId);
      const chainSpecificAddress = config.wrappedAddress.toLowerCase();

      const paymentDefault = [
        { address: ethers.constants.AddressZero, name: config.nativeName },
        { address: config.wrappedAddress, name: config.wrappedName },
      ];
      console.log(data);

      const initialOptions = data?.paymentCoinOptions?.length > 0
        ? data.paymentCoinOptions
        : (data?.paymentCoin?.length > 0 ? data.paymentCoin : []);

      const checkCoin = initialOptions.some(
        (coin) =>
          coin.address.toLowerCase() === zeroAddress ||
          coin.address.toLowerCase() === chainSpecificAddress,
      );

      setPaymentCoinOptions(
        checkCoin ? initialOptions : [...initialOptions, ...paymentDefault],
      );
    };

    fetchData();
  }, [id]);

  return (
    <div>
      {paymentCoinOptions.map((option, index) => (
        <div key={index} style={{ marginBottom: "10px" }}>
          <TextField
            label="Name"
            style={{ marginRight: "10px" }}
            value={option.name}
            onChange={(e) => {
              const newPaymentCoinOptions = [...paymentCoinOptions];
              newPaymentCoinOptions[index].name = e.target.value;
              setPaymentCoinOptions(newPaymentCoinOptions);
            }}
          />
          <TextField
            label="Address"
            value={option.address}
            onChange={(e) => {
              const newPaymentCoinOptions = [...paymentCoinOptions];
              newPaymentCoinOptions[index].address = e.target.value;
              setPaymentCoinOptions(newPaymentCoinOptions);
            }}
          />
          <IconButton onClick={() => deletePaymentOption(index)}>
            <Delete />
          </IconButton>
        </div>
      ))}
      <Button variant="contained" color="primary" onClick={addPaymentOption}>
        Add
      </Button>
      <Button
        style={{ marginLeft: "10px" }}
        variant="contained"
        color="primary"
        onClick={updatePaymentOptions}
      >
        {" "}
        Save{" "}
      </Button>
    </div>
  );
}
